var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Box from "@mui/material/Box";
import style from "./markdown-styles.module.css";

var Content = function Content(props) {
  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      mdContent = _useState2[0],
      setMdContent = _useState2[1];

  useEffect(function () {
    fetch(props.contents).then(function (response) {
      return response.text();
    }).then(function (text) {
      setMdContent(text);
    });
  }, []);

  return React.createElement(
    Box,
    { id: props.id },
    React.createElement(ReactMarkdown, {
      children: mdContent,
      className: style.reactMarkDown,
      remarkPlugins: [remarkGfm]
    })
  );
};

export default Content;